export default "__VITE_ASSET__DWgXg$sF__"